"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELD_MAP = new Map([
    ['availablefromurl', 'URL'],
    ['chapter', 'chapter-number'],
    ['edition', 'edition'],
    ['issn', 'ISSN'],
    ['issue', 'issue'],
    ['medium', 'medium'],
    ['nlmuniqueid', 'id'],
    ['pages', 'page'],
    ['publisherlocation', 'publisher-place'],
    ['publishername', 'publisher'],
    ['reportnumber', 'number'],
    ['volume', 'volume'],
]);
exports.HTML_FIELD_MAP = new Map([
    ['bookname', 'title'],
    ['booktitle', 'title'],
    ['fulljournalname', 'container-title'],
    ['title', 'title'],
]);
